import React from 'react';

import { useIsFetching } from '@tanstack/react-query';

import Spinner from '../Spinner';

import { useUiStore } from '../../store';

export default function GlobalLoader() {
  const isFetchingManually = useUiStore((state) => state.isFetching);

  const isFetching = useIsFetching();

  if (!isFetching && !isFetchingManually) {
    return null;
  }

  return <Spinner />;
}
